<template>
  <div
    class="modal fade show wf-inspiration-overlay inspiration-page-gallery-overlay"
    v-if="imgPreviewOpened"
  >
    <div class="modal-dialog inspiration-full-modal h-100" role="document">
      <div class="modal-content h-100">
        <div class="modal-body h-100">
          <button
            class="wf-inspiration-overlay-button-close btn button-full"
            type="button"
            @click.prevent.stop="
              setImgPreviewOpened(false);
              setIsImageInfoOpened(false);
              $helpers.enableScrolling();
            "
          >
            <span
              class="png-icon png-icon-icons-symbols--k-txtclose"
              aria-label="Close inspiration overlay"
            />
          </button>

          <div class="row h-100">
            <div class="col-md-4 col-sm-3 col-lg-3 h-100">
              <div
                class="wf-inspiration-info-collapse inspiration-page-gallery-info-block collapse-gallery show h-100"
                :class="isMobile ? 'w-100' : ''"
              >
                <div class="wf-inspiration-info inspiration-page-gallery-info">
                  <div class="pdp-heart-icon">
                    <span
                      class="png-icon png-icon-icons-glyph--k-heart cursor-pointer float-right"
                      @click="addToProject(openedImage.mainProduct)"
                    ></span>
                    <a
                      :href="
                        $helpers.getCollectionOverviewUrl(
                          openedImage.mainProduct.collectionCode
                        )
                      "
                      class="
                        secondary-heading
                        info-secondary-heading
                        d-block mr-5 mt-0
                        text-dark text-decoration-none
                      "
                    >
                      {{ openedImage.mainProduct.collectionName }}
                    </a>
                  </div>
                  <div class="path-header">
                    {{
                      $resourceString[
                        "inspiration.images.gallery.in.this.design"
                      ]
                    }}
                  </div>
                  <div class="path-block d-flex flex-wrap">
                    <a
                      class="path d-block text-dark text-decoration-none cart-item-model-no"
                      :href="
                        $helpers.getProductDetailUrl(
                          openedImage.mainProduct.styleNameURL,
                          openedImage.mainProduct.sellingStyleNumber,
                          openedImage.mainProduct.mainColor.colorNumber
                        )
                      "
                    >
                      {{ openedImage.mainProduct.sellingStyleName }}
                      {{ openedImage.mainProduct.sellingStyleNumber
                      }}<Icon
                        class="gallery-info-right-arrow-icon"
                        icon="dashicons:arrow-right-alt"
                      />
                    </a>
                    <a
                      class="path d-block text-dark text-decoration-none"
                      :href="
                        `/tags/?name=${openedImage.mainProduct.productType}`
                      "
                    >
                      {{ openedImage.mainProduct.productType
                      }}<Icon
                        class="gallery-info-right-arrow-icon"
                        icon="dashicons:arrow-right-alt"
                      />
                    </a>
                    <a
                      class="path d-block text-dark text-decoration-none"
                      :href="
                        `/tags/?name=${openedImage.mainProduct.productType}+${openedImage.mainProduct.productCategory}`
                      "
                    >
                      {{ openedImage.mainProduct.productCategory
                      }}<Icon
                        class="gallery-info-right-arrow-icon"
                        icon="dashicons:arrow-right-alt"
                      />
                    </a>
                  </div>
                  <div class="color-image-block">
                    <img
                      :src="
                        $helpers.getColorThumbnailImageUrl(
                          openedImage.mainProduct.sellingStyleNumber,
                          openedImage.mainProduct.mainColor.colorNumber
                        )
                      "
                      :alt="
                        `${openedImage.mainProduct.sellingStyleName}+ ${openedImage.mainProduct.mainColor.colorNumber}`
                      "
                    />
                    <a
                      :href="
                        $helpers.getProductDetailUrl(
                          openedImage.mainProduct.styleNameURL,
                          openedImage.mainProduct.sellingStyleNumber,
                          openedImage.mainProduct.mainColor.colorNumber
                        )
                      "
                      class="d-block text-dark text-decoration-none cart-item-model-no"
                    >
                      {{ openedImage.mainProduct.mainColor.colorName }}
                      {{ openedImage.mainProduct.mainColor.colorNumber
                      }}<Icon
                        class="gallery-info-right-arrow-icon"
                        icon="dashicons:arrow-right-alt"
                      />
                    </a>
                  </div>
                  <div class="see-more-arrow-up w-0" />
                  <a
                    class="see-more-block d-flex text-dark text-decoration-none cart-item-model-no"
                    :href="
                      $helpers.getProductDetailUrl(
                        openedImage.mainProduct.styleNameURL,
                        openedImage.mainProduct.sellingStyleNumber,
                        openedImage.mainProduct.mainColor.colorNumber
                      )
                    "
                  >
                    <wf-load-image
                      :wrapper-class="'see-more-image-block'"
                      image-class=""
                      :src="
                        $helpers.getColorThumbnailImageUrl(
                          openedImage.mainProduct.sellingStyleNumber,
                          openedImage.mainProduct.mainColor.colorNumber
                        )
                      "
                      :alt="
                        `${openedImage.mainProduct.sellingStyleName}+ ${openedImage.mainProduct.mainColor.sellingStyleNumber} `
                      "
                    />
                    <div class="see-more-text m-auto">
                      {{
                        $resourceString["inspiration.images.gallery.see.more"]
                      }}
                      <Icon
                        class="gallery-info-right-arrow-icon"
                        icon="dashicons:arrow-right-alt"
                      />
                    </div>
                  </a>
                  <div
                    class="look-book-block"
                    v-if="openedImage.mainProduct.lookBook"
                  >
                    <div class="look-book-file-name">
                      {{ openedImage.mainProduct.lookBookTitle }}
                    </div>
                    <a
                      :href="openedImage.mainProduct.lookBook"
                      class="
                        call-to-action-button
                        btn btn-white
                        border-dark
                        look-book-button
                      "
                    >
                      <span
                        class="
                          png-icon
                          png-icon-icons-glyph--k-btn-download
                          look-book-icon
                        "
                      />
                      <p class="m-auto">
                        {{
                          $resourceString[
                            "inspiration.images.gallery.look.book"
                          ]
                        }}
                      </p>
                    </a>
                  </div>
                  <div :class="!openedImage.mainProduct.lookBook ? 'mt-2' : ''">
                    <wf-add-to-cart-button-only
                      :selling-style-number="
                        openedImage.mainProduct.sellingStyleNumber
                      "
                      :color-number="
                        openedImage.mainProduct.mainColor.colorNumber
                      "
                      :quantity="1"
                      :save-for-later="false"
                      :inventory-style-number="
                        openedImage.mainProduct.sellingStyleNumber
                      "
                      :is-button="true"
                      :is-disabled="
                        openedImage.mainProduct.mainColor.isSampleAvailable ==
                        true
                          ? false
                          : true
                      "
                    />
                  </div>
                  <div v-if="openedImage.products.length > 0">
                    <div class="other-products">
                      {{
                        $resourceString[
                          "inspiration.images.gallery.other.presented.products"
                        ]
                      }}
                    </div>
                    <ul class="list-unstyled">
                      <li
                        v-for="product in openedImage.products"
                        :key="product.sellingStyleNumber"
                        class="d-flex flex-wrap"
                      >
                        <a
                          :href="
                            $helpers.getProductDetailUrl(
                              product.styleNameURL,
                              product.sellingStyleNumber,
                              color.colorNumber
                            )
                          "
                          v-for="color in product.colors"
                          :key="color.colorNumber"
                          class="
                            other-products-link
                            w-100
                            d-block
                            text-dark text-decoration-none cart-item-model-no
                          "
                        >
                          {{ product.sellingStyleNumber + " in color " }}
                          {{ color.colorNumber }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="product-detail-desc mt-3">
                    <div v-if="openedImage.mainProduct.projectName">
                      <span>
                        {{
                          $resourceString[
                            "inspiration.images.gallery.projectname"
                          ]
                        }}
                        :
                      </span>
                      {{ openedImage.mainProduct.projectName }}
                    </div>
                    <div v-if="openedImage.mainProduct.city">
                      <span>
                        {{ $resourceString["inspiration.images.gallery.city"] }}
                        :
                      </span>
                      {{ openedImage.mainProduct.city }}
                    </div>
                    <div v-if="openedImage.mainProduct.state">
                      <span>
                        {{
                          $resourceString["inspiration.images.gallery.state"]
                        }}
                        :
                      </span>
                      {{ openedImage.mainProduct.state }}
                    </div>
                    <div v-if="openedImage.mainProduct.designFirm">
                      <span>
                        {{
                          $resourceString[
                            "inspiration.images.gallery.designfirm"
                          ]
                        }}
                        :
                      </span>
                      {{ openedImage.mainProduct.designFirm }}
                    </div>
                    <div v-if="openedImage.mainProduct.photographer">
                      <span>
                        {{
                          $resourceString[
                            "inspiration.images.gallery.photographer"
                          ]
                        }}
                        :
                      </span>
                      {{ openedImage.mainProduct.photographer }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8 col-sm-9 col-lg-9 h-100">
              <button
                v-if="!isMyproject"
                class="inspiration-prev-image-button btn button-full"
                type="button"
                @click="changePreviewImage(-1)"
              >
                <Icon
                  icon="ep:arrow-right"
                  color="white"
                  :rotate="2"
                  height="30"
                />
              </button>

              <wf-load-image
                :wrapper-class="'main-preview-image w-100 h-100'"
                :image-class="'w-100 h-100'"
                :src="$helpers.getWidenImgURL(openedImage.embedId, 2000)"
                :alt="openedImage.imageAltText || ''"
              />

              <button
                v-if="!isMyproject"
                class="inspiration-next-image-button btn button-full"
                type="button"
                @click="changePreviewImage(1)"
              >
                <Icon icon="ep:arrow-right" color="white" height="30" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      height="650"
      name="project-wizard-product-content-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      class="my-project-modal"
      :scrollable="true"
    >
      <pc-project-wizard-content-modal
        @closeModal="closeModal($event)"
      ></pc-project-wizard-content-modal>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Icon } from "@iconify/vue2";
import WFLoadImage from "../wf-load-image.vue";
import WfAddToCartButtonOnly from "../wf-add-to-cart-button-only.vue";
import { ContentItemTypes, step1Data } from "../../../stepTree";
import commonMethods from "../../../scripts/common-methods";
import PcProjectWizardContentModal from "../content-wizard-modal/pc-project-wizard-content-modal.vue";
export default {
  props: ["isMyproject"],
  components: {
    Icon,
    "wf-load-image": WFLoadImage,
    WfAddToCartButtonOnly,
    PcProjectWizardContentModal
  },
  computed: {
    ...mapGetters({
      imgPreviewOpened: "inspirationPage/imgPreviewOpened",
      openedImage: "inspirationPage/openedImage",
      isImageInfoOpened: "inspirationPage/isImageInfoOpened",
      getproductSearchResponse: "contentWizard/getproductSearchResponse",
      userIsAuthenticated: "contentWizard/getuserIsAuthenticated"
    })
  },
  data() {
    return {
      isMobile: window.innerWidth < 576
    };
  },

  mounted(){
    this.openModalIfLoggedIn();
  },

  methods: {
    ...mapActions({
      setImgPreviewOpened: "inspirationPage/setImgPreviewOpened",
      changePreviewImage: "inspirationPage/changePreviewImage",
      setIsImageInfoOpened: "inspirationPage/setIsImageInfoOpened",
      setStep1: "contentWizard/setStep1",
      setStep: "contentWizard/setStep",
      setContentType: "contentWizard/setContentType",
      setContentItem: "contentWizard/setContentItem",
      setIsOutOfProject: "contentWizard/setIsOutOfProject",
      resetContent: "contentWizard/resetContent",
      resetContentType: "contentWizard/resetContentType",
      updateProductSearchTerm: "contentWizard/updateProductSearchTerm",
      setIsStep2ItemSelected: "contentWizard/setIsStep2ItemSelected",
      fetchproductSearch: "contentWizard/fetchproductSearch",
      setSelectedProduct: "contentWizard/selectedProduct"
    }),

    closeModal() {
      this.$modal.hide("project-wizard-product-content-modal");
    },

    openModalIfLoggedIn() {
      const urlParams = new URLSearchParams(window.location.search);
      const hash = window.location.hash;
      // Check if openModal parameter exists in query string
      if (
        urlParams.has("openModal") &&
        urlParams.get("openModal") === "gallery-pdp"
      ) {
        this.addToProject();
        setTimeout(()=>{
          commonMethods.removeQueryParam();
        },5000);
        return;
      }
      // Check if openModal parameter exists in fragment identifier
      const hashParams = new URLSearchParams(hash.substring(1));
      if (
        hashParams.has('openModal') &&
        hashParams.get('openModal') === 'gallery-pdp'
      ) {
        this.addToProject();
      }
    },

    async addToProject(value) {
      if (userIsAuthenticated === "true" || userIsAuthenticated === true) {
        this.$modal.show("project-wizard-product-content-modal");
        // Reset Content Wizard State
        this.resetContentType();
        this.resetContent();

        let data = value?value: JSON.parse(localStorage.getItem('productData'));
        localStorage.removeItem('productData');
        localStorage.removeItem('imageData');
        // Set content wizard type
        this.setIsOutOfProject(true);

        // Set Content Wizard New Data
        this.setContentItem({
          productType: data.productType,
          productId: data.sellingStyleNumber,
          productInventoryType: data.productType,
          title: data.sellingStyleName,
          productTitle: data.sellingStyleName + " - " + data.sellingStyleNumber,
          selectedProduct:
            data.sellingStyleName + " - " + data.sellingStyleNumber,
          coverPhoto: null,
          thumbnailUrl: null,
          type: ContentItemTypes.product,
          size: 0
        });

        // Set step data
        this.setStep(2);
        this.setContentType(step1Data.product.defaultType);
        this.setStep1({ selectedType: "product" });

        // Set product data
        await this.updateProductSearchTerm(data.inventoryType);
        this.setIsStep2ItemSelected(false);
        await this.fetchproductSearch().then(() => {
          this.getSelectedProductFromArr(data.sellingStyleNumber);
          this.setIsStep2ItemSelected(true);
          this.setContentItem({
            isItemSelected: true
          });
        });
      } else {
        localStorage.setItem('productData',JSON.stringify(value));
        commonMethods.fallBackURL('gallery-pdp');
      }
    },

    getSelectedProductFromArr(styleNumber) {
      if (this.getproductSearchResponse?.items?.length > 0) {
        this.getproductSearchResponse?.items.forEach(item => {
          if (item.styleNumber.toLowerCase() == styleNumber.toLowerCase())
            this.setSelectedProduct(item);
        });
      } else {
        return [];
      }
    }
  }
};
</script>
